<template>
  <section class="center-panel growth-condition">
    <div class="tag-title">当前生长条件</div>
    <div ref="chartRef" class="condition-chart"></div>
    <div class="condition-grid">
      <span>土壤墒情</span>
      <span>光照强度</span>
      <span>病虫风险</span>
      <strong>68%、适宜</strong>
      <strong>41200lux</strong>
      <strong>低</strong>
      <b>积温2860℃·d</b>
      <b>有效光照</b>
      <b>低风险</b>
    </div>
  </section>
</template>

<script setup>
import * as echarts from "echarts";
import { onBeforeUnmount, onMounted, ref } from "vue";

const chartRef = ref(null);
let chartInstance = null;

function resizeChart() {
  chartInstance && chartInstance.resize();
}

onMounted(() => {
  chartInstance = echarts.init(chartRef.value);
  chartInstance.setOption({
    color: ["#2df8dc", "#ffd95a"],
    series: [
      {
        type: "pie",
        radius: ["69%", "84%"],
        center: ["50%", "55%"],
        startAngle: 222,
        silent: true,
        avoidLabelOverlap: false,
        label: { show: false },
        labelLine: { show: false },
        data: [
          {
            value: 90,
            itemStyle: {
              color: "rgba(39, 255, 224, 0.14)",
              borderRadius: 16,
            },
          },
          {
            value: 25,
            itemStyle: { color: "transparent" },
          },
        ],
        z: 1,
      },
      {
        type: "pie",
        radius: ["69%", "84%"],
        center: ["50%", "55%"],
        startAngle: 222,
        clockwise: true,
        avoidLabelOverlap: false,
        label: { show: false },
        labelLine: { show: false },
        data: [
          {
            value: 68,
            name: "适宜",
            itemStyle: {
              color: "#2df8dc",
              borderRadius: 18,
              shadowBlur: 12,
              shadowColor: "rgba(45, 248, 220, 0.34)",
            },
          },
          {
            value: 22,
            name: "偏高",
            itemStyle: {
              color: "#ffd95a",
              borderRadius: 18,
              shadowBlur: 12,
              shadowColor: "rgba(255, 217, 90, 0.32)",
            },
          },
          {
            value: 25,
            name: "开口",
            itemStyle: { color: "transparent" },
          },
        ],
        z: 3,
      },
      {
        type: "gauge",
        radius: "62%",
        center: ["50%", "55%"],
        startAngle: 222,
        endAngle: -42,
        silent: true,
        axisLine: { show: false },
        axisTick: {
          show: true,
          splitNumber: 4,
          distance: -2,
          length: 3,
          lineStyle: { color: "rgba(220,255,249,0.36)", width: 1 },
        },
        splitLine: { show: false },
        axisLabel: { show: false },
        pointer: { show: false },
        detail: { show: false },
        data: [{ value: 68 }],
        z: 2,
      },
    ],
    graphic: [
      {
        type: "text",
        left: "center",
        top: "43%",
        style: { text: "68%", fill: "#ffffff", font: "700 42px sans-serif", textAlign: "center" },
      },
      {
        type: "text",
        left: "center",
        top: "56%",
        style: { text: "2860℃·d", fill: "#ffffff", font: "700 26px sans-serif", textAlign: "center" },
      },
    ],
  });
  window.addEventListener("resize", resizeChart);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeChart);
  chartInstance && chartInstance.dispose();
});
</script>

<style lang="less" scoped>
@import "../shared.less";

.growth-condition {
  height: 100%;
  padding: 26px 32px 24px;
}

.growth-condition .tag-title {
  font-size: 26px;
}

.condition-chart {
  width: 390px;
  height: 286px;
  margin: 70px auto 10px;
}

.condition-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  row-gap: 8px;
  color: #ffffff;
  text-align: center;
}

.condition-grid span {
  color: #f2fffd;
  font-size: 30px;
  font-weight: 700;
  line-height: 46px;
}

.condition-grid strong {
  color: #ffffff;
  font-size: 30px;
  line-height: 46px;
}

.condition-grid b {
  color: #ffffff;
  font-size: 30px;
  line-height: 46px;
}
</style>
